import React, { useEffect, useState } from 'react';
import { Eye, EyeOff, Fingerprint, Loader2, Lock, User } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { DMPLogo } from '../brand/DMPLogo';
import { officerProfile } from '../../data/officer';
export function OfficerSplash({
  onDone
}: {
  onDone: () => void;
}) {
  useEffect(() => {
    const t = setTimeout(onDone, 2200);
    return () => clearTimeout(t);
  }, [onDone]);
  return <div className="flex h-full flex-col items-center justify-center bg-[#003B71] px-8 text-center text-white" data-id="element-395" data-mp="nvkro9sjx77r">
      <DMPLogo size={112} data-id="element-396" data-mp="wu65jrn2vy27" />
      <div className="mt-6 text-xl font-bold" data-id="element-397" data-mp="wtekvbv0rkqp">ঢাকা মেট্রোপলিটন পুলিশ</div>
      <div className="mt-1 text-[15px] text-white/80" data-id="element-398" data-mp="st44r6dijdy4">এআই প্রসিকিউশন নোটিশ ব্যবস্থাপনা</div>
      <Loader2 className="mt-10 h-6 w-6 animate-spin text-white/70" data-id="element-399" data-mp="2ylswxuavtuz7" />
      <div className="absolute bottom-8 text-[11px] text-white/50" data-id="element-400" data-mp="2ym2ovnfhmc7j">অফিসার অ্যাপ • সংস্করণ ১.০ (প্রোটোটাইপ)</div>
    </div>;
}
export function OfficerLogin({
  onLogin
}: {
  onLogin: () => void;
}) {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!id.trim() || !pw) return setErr('ইউজার আইডি ও পাসওয়ার্ড প্রদান করুন');
    if (id.trim() !== officerProfile.userId || pw !== 'demo@123') return setErr('ইউজার আইডি অথবা পাসওয়ার্ড সঠিক নয়');
    setErr('');
    setLoading(true);
    setTimeout(onLogin, 700);
  };
  return <div className="flex h-full flex-col bg-white" data-id="element-401" data-mp="2zphfu7ky4pj1">
      <div className="flex flex-col items-center bg-[#003B71] px-6 pb-10 pt-14 text-white" data-id="element-402" data-mp="2zno8sr6f83ai">
        <DMPLogo size={84} data-id="element-403" data-mp="34mrbi4yxhxfb" />
        <div className="mt-3 text-lg font-bold" data-id="element-404" data-mp="15bzmg3xv0yg3">ঢাকা মেট্রোপলিটন পুলিশ</div>
        <div className="text-sm text-white/75" data-id="element-405" data-mp="15du6zh57yojn">অফিসার লগইন</div>
      </div>
      <form onSubmit={submit} noValidate className="-mt-5 flex-1 rounded-t-3xl bg-white px-6 pt-7" data-id="element-406" data-mp="1abcjfhig3lwe">
        <label className="block" data-id="element-407" data-mp="12an01a5yay1k">
          <span className="mb-1.5 block text-sm font-medium" data-id="element-408" data-mp="y8je1rlnob21">ইউজার আইডি</span>
          <div className="relative" data-id="element-409" data-mp="yamdt3cm1ijy"><User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-410" data-mp="1c8av617gy7k9" /><Input value={id} onChange={e => setId(e.target.value)} className="h-12 pl-9" placeholder="dmp.rakib" data-id="element-411" data-mp="1c5y7d7f152za" /></div>
        </label>
        <label className="mt-4 block" data-id="element-412" data-mp="1l87gbsungoak">
          <span className="mb-1.5 block text-sm font-medium" data-id="element-413" data-mp="1l764vn9q1zsb">পাসওয়ার্ড</span>
          <div className="relative" data-id="element-414" data-mp="1h6m84kt28y6p">
            <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-415" data-mp="1h5b20ec57ecf" />
            <Input type={show ? 'text' : 'password'} value={pw} onChange={e => setPw(e.target.value)} className="h-12 pl-9 pr-10" placeholder="••••••••" data-id="element-416" data-mp="1v0wnibj63g03" />
            <button type="button" onClick={() => setShow(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500" aria-label="পাসওয়ার্ড দেখুন" data-id="element-417" data-mp="24y1d6lc81tln">{show ? <EyeOff className="h-4 w-4" data-id="element-418" data-mp="2jjoxc6ifcy4i" /> : <Eye className="h-4 w-4" data-id="element-419" data-mp="2jkqcon6h46s1" />}</button>
          </div>
        </label>
        {err && <p role="alert" className="mt-3 rounded-md bg-[#FCE9EA] px-3 py-2 text-sm text-[#B4232A]" data-id="element-420" data-mp="2nlsaczkqsarw">{err}</p>}
        <Button type="submit" className="mt-6 h-12 w-full text-base" disabled={loading} data-id="element-421" data-mp="29man4on3h5kn">{loading ? <Loader2 className="h-5 w-5 animate-spin" data-id="element-422" data-mp="2ek2jpvyopfv6" /> : 'লগইন করুন'}</Button>
        <button type="button" onClick={() => {
        setId(officerProfile.userId);
        setPw('demo@123');
        setErr('');
      }} className="mt-4 flex w-full items-center justify-center gap-2 text-sm text-[#1769AA]" data-id="element-423" data-mp="1zvppb3f8w52s">
          <Fingerprint className="h-4 w-4" data-id="element-424" data-mp="1quzy6d0xj2ve" /> ডেমো: নমুনা অফিসার তথ্য বসান
        </button>
        <p className="mt-6 text-center text-[11px] text-slate-400" data-id="element-425" data-mp="1qt6nmmn73yi4">শুধুমাত্র নিবন্ধিত ডিএমপি ডিভাইসে ব্যবহারযোগ্য</p>
      </form>
    </div>;
}